import * as React from "react";

import { LoaderType1 } from "@visualizeroi/vroi-custom-components";

type Props2 = {};

const LoadingView = ({}: Props2) => {
  return (
    <>
      <div className="loader_header">Generating your report</div>
      <div className="loader_header_desc">
        Hold tight while your custom report is being generated ...
      </div>
      <LoaderType1 className="loader_class" />
    </>
  );
};

export default LoadingView;
